'use strict';

const SoaModel = require('bunsen/models/SoaModel');
const endpoints = require('dibs-endpoints');
const RecommendationItems = require('bunsen/collections/identity/RecommendationItems');
const Backbone = require('dibs-backbone');

const Recommendation = SoaModel.extend({
    url: endpoints.recommendations(),

    relations: [{
        type: Backbone.Many,
        key: 'items',
        collectionType: RecommendationItems
    }]
});

module.exports = Recommendation;



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/Recommendation.es.js